//import { ObjectId } from 'bson';

import { InvoiceAttachmentFragment } from '../../GraphQL/fragments';

export type Pagination = {
    totalCount: number;
    page: number;
    pageCount: number;
};

export type Page = {
    page: number;
    limit: number;
};

/* shared*/
export type Address = {
    street?: string;
    postalCode?: number;
    city?: string;
    governorate?: string;
    country?: string;
};

export type attachmentsUploaded = {
    uid?: string;
    size?: number;
    name?: string;
    type?: string;
    url?: string;
};

export type IdentityCheckStatus = 'All' | true | false;
export type VehiculeStatus = true | false;
export type CouponStatus = true | false;
export type Calendar = 'Default' | 'This month' | 'This year' | 'Whole time';
export const allIdentityCheckStatus = [
    { label: 'All', value: 'All' },
    { label: 'Checked', value: 'Checked' },
    { label: 'Not checked', value: 'NotChecked' },
];
export const allVehiculeStatus: VehiculeStatus[] = [true, false];
export const allVehiculeTypes: string[] = ['E-Bike', 'E-Scooter', 'E-Moped', 'E-Cargo', 'E-Car'];
export const allPowerTypes: string[] = ['Solar Dock', 'Removable Battery', 'Power Plug'];
export const allOperatorTypes: string[] = ['Business', 'Partner', 'STASIA Mobility'];
export const allLevelTypes: string[] = ['Primary', 'Secondary'];
export const allPassTypeTypes: string[] = ['Weekend', 'Monthly', 'Daily', 'AnyTime', 'Student'];
export const allCouponTypes: string[] = ['Refund', 'Gift', 'Promo Code'];
export const allMicroCouponTypes: string[] = ['Mobility Voucher', 'Mobility Promo'];
export const allCouponsStatus: CouponStatus[] = [true, false];
export const allCalendarsTypes: Calendar[] = ['Default', 'This month', 'This year', 'Whole time'];
export const allVehiculesProblemStatus: string[] = ['Solved', 'InProgress', 'Issue'];
export const allPriceUnitsTypes: string[] = ['Month', 'Day', '3 Months'];
export const allRegisterStatusTypes: string[] = ['Pending', 'In progress', 'Confirmed'];
export const allAccountStatusTypes: string[] = ['Active', 'InActive', 'DocumentCheck'];
export const allRequestBookingStatusTypes: string[] = ['Planned', 'Assigned', 'Booked', 'Cancelled'];

export const allColorOptions: { value: string; label: string; hex: string }[] = [
    { value: 'red', label: 'Red', hex: '#FF0000' },
    { value: 'blue', label: 'Blue', hex: '#0000FF' },
    { value: 'black', label: 'Black', hex: '#000000' },
    { value: 'white', label: 'White', hex: '#FFFFFF' },
    { value: 'silver', label: 'Silver', hex: '#C0C0C0' },
    { value: 'gray', label: 'Gray', hex: '#808080' },
    { value: 'green', label: 'Green', hex: '#008000' },
    { value: 'yellow', label: 'Yellow', hex: '#FFFF00' },
    { value: 'orange', label: 'Orange', hex: '#FFA500' },
    { value: 'brown', label: 'Brown', hex: '#8B4513' },
    { value: 'purple', label: 'Purple', hex: '#800080' },
    { value: 'pink', label: 'Pink', hex: '#FFC0CB' },
    { value: 'gold', label: 'Gold', hex: '#FFD700' },
    { value: 'beige', label: 'Beige', hex: '#F5F5DC' },
    { value: 'turquoise', label: 'Turquoise', hex: '#40E0D0' },
    { value: 'burgundy', label: 'Burgundy', hex: '#800020' },
    { value: 'charcoal', label: 'Charcoal', hex: '#36454F' },
    { value: 'ivory', label: 'Ivory', hex: '#FFFFF0' },
    { value: 'champagne', label: 'Champagne', hex: '#F7E7CE' },
    { value: 'lime', label: 'Lime', hex: '#00FF00' },
];

export const AllCarModels: { value: string; label: string }[] = [
    { value: 'Audi', label: 'Audi' },
    { value: 'BMW', label: 'BMW' },
    { value: 'BYD', label: 'BYD' },
    { value: 'Citroën', label: 'Citroën' },
    { value: 'Cupra', label: 'Cupra' },
    { value: 'Dacia', label: 'Dacia' },
    { value: 'Fiat', label: 'Fiat' },
    { value: 'Ford', label: 'Ford' },
    { value: 'Honda', label: 'Honda' },
    { value: 'Hyundai', label: 'Hyundai' },
    { value: 'Isuzu', label: 'Isuzu' },
    { value: 'Iveco', label: 'Iveco' },
    { value: 'Jeep', label: 'Jeep' },
    { value: 'Kia', label: 'Kia' },
    { value: 'Mahindra', label: 'Mahindra' },
    { value: 'Mazda', label: 'Mazda' },
    { value: 'Mercedes-Benz', label: 'Mercedes-Benz' },
    { value: 'Nissan', label: 'Nissan' },
    { value: 'Opel', label: 'Opel' },
    { value: 'Peugeot', label: 'Peugeot' },
    { value: 'Renault', label: 'Renault' },
    { value: 'Skoda', label: 'Skoda' },
    { value: 'Tesla', label: 'Tesla' },
    { value: 'Toyota', label: 'Toyota' },
    { value: 'Volkswagen', label: 'Volkswagen' },
    { value: 'Volvo', label: 'Volvo' },
    { value: 'wallyscar', label: 'Wallyscar' },
    { value: 'Beko', label: 'Beko' },
    { value: 'Autre', label: 'Autre' },
];

export type DocumentType = 'ID_CARD' | 'DRIVING_LICENSE';
export enum DocumentTypeEnums {
    ID_CARD = 'ID_CARD',
    DRIVING_LICENSE = 'DRIVING_LICENSE',
}

export interface ProcessedDocument {
    bypassVerification: boolean;
    fullName?: string;
    documentNumber?: string;
    personalNumber?: string;
    birthDate?: string;
}

/* Rider */

export type Rider = {
    _id: string;
    logicalId: number;
    fullName: string;
    email: string;
    phoneNumber: string;
    birthday: string;
    riderPhoto: RIDER_ATTACHMENT;
    currentLocation: RIDER_Location;
    isPaymentDefaultMethod: boolean;
    paymentMethod: Payment_Method;
    walletBalance: number;
    isLogged: Boolean;
    signingMethod: SigningMethod;
    idProvider: string;
    privacy: Privacy;
    gender: string;
    country: string;
    idCardMetaData: IdCardMetaData;
    idCardPhoto: RIDER_ATTACHMENT;
    riderSelfie: RIDER_ATTACHMENT;
    identityCheck: boolean;
    ridePassId?: RidePass;
    mobileAppVersion?: string;
    createdDate?: Date;
};

export type RIDER_ATTACHMENT = {
    uid: string;
    size: number;
    name: string;
    type: string;
    url: string;
    isMainImageAttachment: boolean;
};

export type RIDER_Location = {
    latitude: number;
    longitude: number;
    timestamp: number;
};

export type Payment_Method = {
    konnect: boolean;
    ooredooPayment: boolean;
    creditCard: boolean;
};

export type IdCardMetaData = {
    documentName: string;
    ICAOCode: string;
    dCountryName: string;
    dDescription: string;
    dYear: string;
};

export type Privacy = {
    emailMarketing: boolean;
    pushNotifications: boolean;
    updateFeatures: boolean;
    serveysRequest: boolean;
    serviceUpdates: boolean;
};

export type SigningMethod = 'Facebook' | 'Google' | 'Phone';

export type RiderQueryFilter = {
    search?: string;
    gender?: string;
    signingMethod?: SigningMethod;
    dateRange?: DateRangeValue;
    operatorId?: string;
    identityCheck?: string | boolean;
} & Page;
export type SignUpRangeValue = { fromDate: string; toDate: string };

export type RiderPageable = { data: Rider[]; pagination: Pagination };

/* Trip */
export type Trip = {
    _id: string;
    logicalId: number;
    startPoint?: Location;
    endPoint?: Location;
    startDate?: Date;
    endDate?: Date;
    status?: string;
    dropPhoto?: TRIP_ATTACHMENT;
    operatorId?: string;
    riderId?: Rider;
    vehiculeId?: Vehicule;
};

export type TRIP_ATTACHMENT = {
    uid: string;
    size: number;
    name: string;
    type: string;
    url: string;
};

export type Location = { latitude: number; longitude: number };

export type TripQueryFilter = { search?: string; status?: string; dateRange?: DateRangeValue };
export type DateRangeValue = { fromDate: string; toDate: string };

/* PlanTaxi */
export type LocationPlanTaxi = {
    type?: string;
    label: string;
    coordinates: {
        longitude: number;
        latitude: number;
    };
};

export type PlanTaxiRequest = {
    _id: string;
    logicalId: number;
    startLocation: LocationPlanTaxi;
    endLocation: LocationPlanTaxi;
    budget: number;
    recommendedPrice: number;
    paymentMethod: string;
    tripDuration: number;
    trafficDelayPrice: number;
    trafficDelay: number;
    trafficCost: number;
    trafficLevel: string;
    nbrePassenger: number;
    nbreLuggage: number;
    note: string;
    status: string;
    startTripCode: string;
    distanceStartToEnd: number;
    isRated: boolean;
    isInstantAccept: boolean;
    discount: PlanTaxiRequestDiscount;
    changeRequest: ChangeRequest;
    createdDate: Date;
};

export type PlanTaxiRequestDiscount = {
    type: string;
    description: string;
    amount: number;
    reduction: number;
    fareCoveredByCompany: number;
    finalFare: number;
    couponId: string;
};

export type ChangeRequest = {
    endLocation?: Location;
    changePrice?: number;
    tripDuration?: number;
    finalFare?: number;
    prevFinalFare?: number;
    distanceStartToEnd?: number;
    trafficDelayPrice?: number;
    trafficDelay?: number;
    trafficCost?: number;
    trafficLevel?: string;
    isAccepted?: boolean;
};

export type PlanTaxiResponse = {
    passengerId: Rider;
    taxiOfferId: TaxiOffer;
    couponId: Coupon;
} & PlanTaxiRequest;

export type PlanTaxiRequestQueryFilter = {
    search?: string;
    status?: string;
    dateRange?: DateRangeValue;
} & Page;

export type PlanTaxiRequestPageable = {
    data: PlanTaxiResponse[];
    pagination: Pagination;
};

/* TaxiOffer */
export type TaxiOffer = {
    _id?: string;
    logicalId: number;
    offerPrice: number;
    status: string;
    tripStartTime?: Date;
    planTaxiRequestId: PlanTaxiRequest;
    taxiDriver?: TaxiDriver;
    distanceCurrentLocationToStart?: number;
};

/* Vehicule */

export type Vehicule = {
    _id: string;
    logicalId: number;
    vehiculeType?: string;
    qrcode?: string;
    mileage?: number;
    status?: boolean;
    batteryLevel?: number;
    city?: string;
    powerType?: string;
    operatedDate?: string;
    location?: LocationVehicule;
    operatorId?: string;
    pricingId?: Pricing;
};

export type VehiculeInput = Partial<Omit<Vehicule, 'logicalId' | '_id'>>;

export type LocationVehicule = { type: string; coordinates: vehiculeCoordinates };
export type vehiculeCoordinates = { longitude: number; latitude: number };

export type VehiculeQueryFilter = {
    status?: boolean;
    cities?: string[];
    types?: string[];
    batteryLevelRange?: BatteryLevelRangeValue;
    dateRange?: OperatedDateRangeValue;
    operatorId?: string;
};
export type BatteryLevelRangeValue = { minLevel: number; maxLevel: number };
export type OperatedDateRangeValue = { fromDate: string; toDate: string };

/* Operator */
export type Operator = {
    _id: string;
    logicalId: number;
    name?: string;
    website?: string;
    phone?: string;
    email?: string;
    description?: string;
    tva?: string;
    type?: string;
    logo?: attachmentsUploaded;
    address?: Address;
    settingId?: Setting;
};

export type OperatorQueryFilter = { search?: string; cities?: string[]; types?: string[]; _id: string };
export type FileUpload = { createReadStream: () => any /* Readable */; filename: string; mimetype: string };

export type OperatorInput = Partial<
    Omit<Operator, 'logicalId'> & {
        attachmentFile: File | Promise<FileUpload>;
    }
>;

// Setting //
export type SettingQueryFilter = { search?: string; types?: string[] };

export type Setting = {
    _id: string;
    logicalId: number;
    fullname?: string;
    password?: string;
    email?: string;
    sectionRoles?: string[];
    operatorId?: Operator;
};

// City //
export type City = {
    _id: string;
    logicalId: number;
    country: string;
    governorate: string;
    cityName: string;
    longitude: number;
    latitude: number;
};

// Login //
export type TokenResponse = {
    accessToken?: string;
    operatorId?: string;
};

export type RefrechResponse = {
    accessToken?: string;
};

export type LoginInput = { email?: string; password?: string };

// Reset Password //
export type ResetTokenResponse = {
    resetToken?: string;
};

export type ResetPasswordRequestInput = { email?: string };

export type ResetPasswordInput = { email?: string; newPassword?: string; resetToken?: string };

// Pricing //
export type Pricing = {
    _id: string;
    logicalId: number;
    name?: string;
    note?: string;
    minutePrice?: number;
    unlockPrice?: number;
    vehiculeType?: string;
    level?: string;
};

export type AreaMap = {
    id: string;
    coord: Coord[];
};

export type timeSlot = {
    startTime: string;
    endTime: string;
    percentage: number;
};

export type PricingTaxi = {
    _id: string;
    logicalId?: number;
    serviceName?: string;
    selectedCity?: string;
    // klmRange?: string[],
    timeSlot?: timeSlot[];
    note?: string;
    areaMap?: AreaMap;
    zoneBasePercentage?: number;
};
export type PricingTaxiQueryFilterMGT = { search?: string; selectedCity?: string[] };

// basic pricing taxi
export type RequestTaxiStatus = 'Open' | 'Booked' | 'OnGoing' | 'InDrive' | 'Canceled' | 'Closed';
export const allRequestTaxiStatus: RequestTaxiStatus[] = ['Open', 'Booked', 'OnGoing', 'InDrive', 'Canceled', 'Closed'];

export type CreateBasicPricingTaxiInput = Partial<Omit<BasicPricingTaxi, '_id'>>;
export type UpdateBasicPricingTaxiInput = Partial<Omit<BasicPricingTaxi, 'logicalId'>>;

export type BasicPricingTaxi = {
    _id: string;
    logicalId?: string;
    rangeName?: string;
    minDistance?: number;
    maxDistance?: number;
    pricePerKm?: number;
};

// Pass //
export type Pass = {
    _id: string;
    logicalId: number;
    name?: string;
    description?: string;
    priceUnit?: string;
    discount?: number;
    duration?: number;
    initialPrice?: number;
    minutePrice?: number;
    unlockPrice?: number;
    vehiculeType?: string;
};

// RidePass //
export type RidePass = {
    _id: string;
    logicalId: number;
    name?: string;
    description?: string;
    priceUnit?: string;
    discount?: number;
    duration?: number;
    initialPrice?: number;
    startDate?: string;
    endDate?: string;
    vehiculeType?: string;
    minutePrice?: number;
    unlockPrice?: number;
};

/* Coupon */
export type Coupon = {
    _id: string;
    logicalId: number;
    operatorId?: string;
    title: string;
    description: string;
    amount: number;
    reduction: number;
    code: string;
    startingDate: Date;
    expirationDate: Date;
    isExpiredDate: boolean;
    isMultiple: boolean;
    isMultipleTarget: boolean;
    status: boolean;
    isUsed: boolean;
    type: string;
};

export type UpdateCouponStatusInput = { _id: string; status: boolean };

export type CouponQueryFilter = { search?: string; types?: string[]; status?: boolean; dateRange?: DateRangeValue };
export type CouponDateRangeValue = { fromDate: string; toDate: string };

// Campaign //
export type Campaign = {
    _id: string;
    logicalId: number;
    title?: string;
    description?: string;
    targetAudience?: string;
    startingDate?: string;
    endDate?: string;
    status?: boolean;
};

/* Reports */
export type MapTaxiBusinessUsersQueryFilter = {
    search: string;
    userType: string;
    active: string;
    online: string;
    updatedWithin: string;
};

export type MapTaxiBusinessUsers = {
    riders: MapTaxiBusinessRiders[];
    drivers: MapTaxiBusinessDrivers[];
};

export type MapTaxiBusinessRiders = {
    _id: string;
    fullName: string;
    userPhotoUrl: string;
    currentLocation: RIDER_Location;
    isIdentity: boolean;
    isOnline: boolean;
    updatedDate: string;
};

export type MapTaxiBusinessDrivers = {
     _id: string;
    fullName: string;
    userPhotoUrl: string;
    currentLocation: RIDER_Location;
    isActive: boolean;
    isOnline: boolean;
    updatedDate: string;
};

export type LoginMethodReport = {
    loginMethod: string;
    total: number;
};

export type ReportsCounters = {
    totalTrips: number;
    totalRiders: number;
    totalMileage: number;
    totalRevenue: number;
    loginMethods: LoginMethodReport[];
};

export type statusDrivers = {
    driverName: string;
    driverPhoto: string;
    isDriverOnline: boolean;
    updatedDate: string;
};

export type statusRiders = {
    riderName: string;
    riderPhoto: string;
    isRiderOnline: boolean;
    updatedDate: string;
};

export type ReportsCountersTaxiBusiness = {
    totalCompletedTrips: number;
    totalTaxiDrivers: number;
    totalActiveAccountStatusDrivers: number;
    totalPendingRegisterStatusDrivers: number;
    totalDistance: number;
    totalOnlineDrivers: number;
    totalEarningsSubscription: number;
    totalCommissionAmount: number;
    totalCouponCost: number;
    totalTripsWithCoupon: number;
    netRevenue: number;
    statusDrivers: statusDrivers[];
    totalOnlineRiders: number;
    statusRiders: statusRiders[];
};

export type ReportTrip = {
    year: string;
    value: number;
    category: string;
};

export type ReportCO2 = {
    month: string;
    estimate: number;
};

export type ReportsQueryFilter = {
    quicklyCalanderSlot?: Calendar;
    dateRange?: ReportsDateRangeValue;
    operatorId?: string;
};
export type ReportsDateRangeValue = { fromDate: string; toDate: string };

// Campaign //
export type CampaignNotificationResult = {
    success: boolean;
    message: string;
    totalRecipients: number;
    successCount: number;
    failedCount: number;
    failedRecipients: CampaignRecipient[];
};

export type CampaignRecipient = {
    userId: string;
    userType: 'RIDER' | 'DRIVER';
    fcmToken: string;
};

// Map //
export type mapCityCoordinates = {
    longitude: number;
    latitude: number;
};

export type LocationCityMap = {
    type: string;
    coordinates: mapCityCoordinates;
};

export type Coord = {
    lat: number;
    lng: number;
};

export type Zone = {
    id_zone: string;
    name_zone: string;
    coord: Coord[];
};

export type CityMap = {
    _id: string;
    logicalId?: number;
    cityName: string;
    location: LocationCityMap;
    zones: Zone[];
};

// Support //

export type Support = {
    email: string;
    subject: string;
    description: string;
    operatorId?: string;
};

export type SupportInput = Partial<
    Support & {
        attachmentsFiles: File[] | Promise<FileUpload>[];
    }
>;

// VehiculeProblem //

export type VehiculeProblem = {
    _id: string;
    logicalId: number;
    description: string;
    qrCode: string;
    status: string;
    problemPhotos: VehiculeProblem_Attachment[];
    currentLocation: LocationVehicule;
};

export type VehiculeProblem_Attachment = {
    uid: string;
    size: number;
    name: string;
    type: string;
    url: string;
    isMainImageAttachment: boolean;
};

// welcome Contact formulaire //

export type ContactInput = {
    email: string;
    subject: string;
    firstName: string;
    description: string;
};

// invoice

export type InvoiceAttributes = {
    logicalId: number;
    amount: number;
    status: string;
    tripDuration: number;
    startDate: Date;
    endDate: Date;
    reference: string;
    vehiculeIdentifier: string;
    distance: number;
    invoiceAttachment: InvoiceAttachment;
    tripId: Trip;
    riderId: Rider;
    couponId: Coupon;
};

export type InvoiceAttachment = {
    uid: string;
    size: number;
    name: string;
    type: string;
    url: string;
};

export type Invoice = { _id: string } & InvoiceAttributes;

export type PagingInput = { limit: number; offset?: number };

export type InvoicesFetchInput = { id: string; invoiceType?: string; paging?: PagingInput };
export type TripsHistoryFetchInputMgt = { id: string; invoiceType?: string } & Page;

export type InvoiceHistory = {
    totalCount: number;
    data: {
        _id: string;
        monthTitle: string;
        isCurrentMonth: boolean;
        data: [
            {
                date: string;
                reference: string;
                vehiculeIdentifier: string;
                distance: number;
                startTime: string;
                endTime: string;
                invoiceType: string;
                startLocation: string;
                endLocation: string;
                planTaxiRequestId: string;
                taxiDriverFullName: string;
                tripDuration: string;
                paymentStatus: string;
                totalCost: number;
            },
        ];
    };
};

export type TripsRiderHistoryData = {
    _id: string;
    date: string;
    reference: string;
    invoiceType: string;
    taxiDriverFullName: string;
    status: string;
    invoiceAttachment: InvoiceAttachment;
};

export type TripsRiderHistoryPageable = {
    data: TripsRiderHistoryData[];
    pagination: Pagination;
};

export type TripsDriverHistoryData = {
    _id: string;
    date: string;
    reference: string;
    invoiceType: string;
    status: string;
    riderFullName: string;
    reviewRating?: number;
    reviewCompliment?: string;
    invoiceAttachment?: InvoiceAttachment;
};

export type TripsDriverHistoryPageable = {
    data: TripsDriverHistoryData[];
    pagination: Pagination;
};

// TaxiDriver //

export type TaxiDriver = {
    _id: string;
    logicalId: number;
    fullName: string;
    birthday: Date;
    email: string;
    password: string;
    phoneNumber: string;
    driverPhoto: RIDER_ATTACHMENT;
    referralCode: string;
    usedReferralCode: string;
    marque: string;
    model: string;
    year: string;
    immatriculation: string;
    color: string;
    idCard: string;
    licenseNumber: string;
    bankName: string;
    bankAccountNumber: string;
    documentsPhotos: TaxiDriver_Attachment[];
    isDriverOnline: boolean;
    fcmToken: string;
    totalRides: number;
    rating: number;
    currentLocation: RIDER_Location;
    registerStatus: string;
    accountStatus: string;
    expiredInsuranceDate?: string;
    expiredAccountDate?: string;
    commissionRate?: number;
    workRangeKm?: number;
    isRewardedReferral: boolean;
    rewardedReferralCount?: number;
    monthlyFee?: number;
    signUpType: string;
    note?: string;
    mobileAppVersion?: string;
    createdDate: Date;
};

export type TaxiDriverQueryFilterMGT = {
    search?: string;
    accountStatusTypes?: string[];
    types?: string[];
    dateRange?: DateRangeValue;
} & Page;

export enum AccountStatusEnums {
    Active = 'Active',
    InActive = 'InActive',
    DocumentCheck = 'DocumentCheck',
}
export enum registerStatusEnums {
    Pending = 'Pending',
    InProgress = 'In progress',
    Confirmed = 'Confirmed',
}
export enum RewardStatus {
    NotEligible = 'NotEligible',
    Eligible = 'Eligible',
    Rewarded = 'Rewarded',
    Notified = 'Notified',
}

export type TaxiDriver_Attachment = {
    uid: string;
    size: number;
    name: string;
    type: string;
    url: string;
};

export type TaxiDriverInput = Partial<Omit<TaxiDriver, '_id' | 'logicalId'>> & {
    attachmentsFiles: File[] | Promise<FileUpload>[];
};

export type TaxiDriverUpdateInput = Partial<
    TaxiDriver & {
        attachmentsFile: File | Promise<FileUpload>;
    }
>;

export type TaxiDriverAndTokenResponse = {
    taxiDriver: TaxiDriver;
    accessToken: string;
};

export type TaxiDriverPageable = { data: TaxiDriver[]; pagination: Pagination };

// Request Booking //

export type RequestBooking = {
    _id: string;
    logicalId: number;
    pickUpLocation: string;
    dropOffLocation: string;
    tripDate: Date;
    nbrePassenger: number;
    nbreluggage: number;
    passengerName: string;
    passengerEmail: string;
    passengerPhoneNumber: string;
    note: string;
    status: string;
    operatorId?: Operator;
};

export type RequestBookingInput = Partial<Omit<RequestBooking, 'logicalId' | '_id'>>;

export type RequestBookingQueryFilterMGT = {
    search?: string;
    requestBookingStatusTypes?: string[];
    operatorId?: string;
};

export type WeeklyTripDriver = {
    label: string;
    completed: number;
    canceled: number;
    value: number;
};

export type DriverTripsAndEarningsResponse = {
    toDay: string;
    bonus: number;
    numberRides: number;
    numberCanceledOffers: number;
    distance: number;
    earningSummary: number;
    commissionRate: number;
    commissionAmount: number;
    weeklyTrips: [WeeklyTripDriver];
};

export type TaxiDriverEarningsFilter = {
    driverId: string;
    startDate?: Date;
    endDate?: Date;
};

export type TripsRiderFilter = {
    id: string;
    startDate?: Date;
    endDate?: Date;
};

export type WeeklyTripRider = {
    label: string;
    completed: number;
    canceled: number;
};

export type RiderTripsSummaryResponse = {
    completedTrips: number;
    canceledTrips: number;
    couponsUsed: string[];
    weeklyTrips: [WeeklyTripRider];
};

export type CanceledJobDriverHistoryData = {
    logicalId: string;
    date: string;
    status: string;
    riderName: string;
};

export type CanceledJobDriverHistoryPageable = {
    pagination: Pagination;
    data: CanceledJobDriverHistoryData[];
};
export type CanceledJobFetchInputMgt = {
    id: string;
} & Page;

export type FinancialOverview_Attachment = {
    uid: string;
    size: number;
    name: string;
    type: string;
    url: string;
};

export type FinancialSummary = { subscriptions: number; commissions: number; taxOnRevenue: number; netAmount: number };
export type Period = { fromDate: string; toDate: string; label: string };

export type FinancialOverview = {
    _id: string;
    logicalId: number;
    period: Period;
    driversCount: number;
    financialSummary: FinancialSummary;
    financialOverviewPdf: FinancialOverview_Attachment;
    createdDate: string;
};
export type FinancialOverviewInput = {
    fromDate: string;
    toDate: string;
};

//  currency rate //
export type CurrencyRate = {
    _id?: string;
    logicalId?: number;
    currency: string;
    rate: number;
    updatedDate?: Date;
};

export type IdCardProcessResult = {
    bypassVerification?: boolean;
    data?: string;
    status?: number;
};
